<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="searchMenu">
          <!-- <el-button
            size="small"
            class="el-icon-delete"
            @click.stop="searchClear"
            style="width: 80px;left: -88px;position: relative;"
          >清空</el-button>-->
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="typeEdit(scope)"
          >编辑</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadExcelExportCredit"
          >下载Excel</el-button>
        </template>
      </avue-crud>
      <el-dialog
        :visible.sync="dialogTypeEditVisible"
        title="商户信用值"
        center
        width="300px"
      >
        <div style="display: flex;">
          <div style="margin-right:20px">结算方式:</div>
          <div>
            <el-radio
              v-model="clearType"
              label="CASH"
            >现款现货</el-radio>
            <el-radio
              v-model="clearType"
              label="INSTALLMENT"
            >月结</el-radio>
          </div>
        </div>
        <el-form v-if="clearType == 'INSTALLMENT'">
          <div>结算日期:</div>
          <el-form-item>
            <el-select
              v-model="clearDate"
              clearable
              placeholder="请选择月度结算日期"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="typeButton">
          <el-button
            round
            size="mini"
            @click="dialogTypeEditVisible = false"
          >&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button
            round
            type="danger"
            size="mini"
            @click="typeEditOk"
          >&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

    <script>
import { mapGetters } from "vuex";
import { creditOption } from "@/const/salesCloud/creditOption";
import {
  statusSearch,
  updateWorkOrderMerchants,
  evaluation,
  immediatePay,
  findItemsByCategory,
  insertWorkOrderMerchants,
  userPass,
  userRefused,
  cancelWorkOrder
} from "@/api/salesCloud/workOrder";
import {
  InvoiceSystemV2Statistics,
  updateCredit,
} from "@/api/salesCloud/credit";
import {
  InvoiceSystemV2StatisticsDownload
} from "@/api/salesCloud/credit";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { getCompany } from "@/util/auth";
import { exportExcel } from "xlsx-oc";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { excelaxios } from "@/util/excelaxios";
import { log } from "util";
export default {
  name: "credit",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: creditOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogTypeEditVisible: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      clearDate: "",
      options: [
        //日期31日
        {
          value: "1",
          label: "1"
        },
        {
          value: "2",
          label: "2"
        },
        {
          value: "3",
          label: "3"
        },
        {
          value: "4",
          label: "4"
        },
        {
          value: "5",
          label: "5"
        },
        {
          value: "6",
          label: "6"
        },
        {
          value: "7",
          label: "7"
        },
        {
          value: "8",
          label: "8"
        },
        {
          value: "9",
          label: "9"
        },
        {
          value: "10",
          label: "10"
        },
        {
          value: "11",
          label: "11"
        },
        {
          value: "12",
          label: "12"
        },
        {
          value: "13",
          label: "13"
        },
        {
          value: "14",
          label: "14"
        },
        {
          value: "15",
          label: "15"
        },
        {
          value: "16",
          label: "16"
        },
        {
          value: "17",
          label: "17"
        },
        {
          value: "18",
          label: "18"
        },
        {
          value: "19",
          label: "19"
        },
        {
          value: "20",
          label: "20"
        },
        {
          value: "21",
          label: "21"
        },
        {
          value: "22",
          label: "22"
        },
        {
          value: "23",
          label: "23"
        },
        {
          value: "24",
          label: "24"
        },
        {
          value: "25",
          label: "25"
        },
        {
          value: "26",
          label: "26"
        },
        {
          value: "27",
          label: "27"
        },
        {
          value: "28",
          label: "28"
        },
        {
          value: "29",
          label: "29"
        },
        {
          value: "30",
          label: "30"
        },
        {
          value: "31",
          label: "31"
        }
      ],
      clearType: "CASH",
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {}
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    typeEditOk() {
      console.log(this.clearDate, "日期");
      console.log(this.clearType, "结算类型");
      let params = {};
      let id = "";
      if (this.clearType == "CASH") {
        console.log("CASH");
        console.log(this.clearId);
        id = this.clearId;
        params.clearingType = "CASH";
      } else {
        console.log("INSTALLMENT");
        console.log(this.clearId);
        console.log(typeof this.clearDate);
        id = this.clearId;
        params.clearingTime = this.clearDate;
        params.clearingType = "INSTALLMENT";
        if (this.clearDate == "") {
          this.$message({
            showClose: true,
            message: "请选择结算日期",
            type: "error"
          });
          return;
        }
      }
      updateCredit(id, params).then(res => {
        console.log(res, "编辑接口返回");
        //重置数据
        this.clearDate = "";
        this.clearType = "CASH";
        this.dialogTypeEditVisible = false;
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "修改成功",
            type: "success"
          });
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
        }
        this.handleList();
      });
      // this.$message({
      //         showClose: true,
      //         message: "点锤子点",
      //         type: "error"
      //       });
    },
    typeEdit(scope) {
      this.dialogTypeEditVisible = true;
      console.log("rowlist", scope);
      this.clearId = scope.row.id;
    },
    stockRemovalSubmit() {
      console.log(this);
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },
    statusChange() {
      //下拉框状态发生改变时
      // console.log(this.value);
      let params = this.value;
      statusSearch(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      // console.log(this.$refs.crud.resetForm)
      this.downloadData = params;
      console.log(params);
      console.log(this);
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm;
      console.log(this.$refs.crud.searchForm, "搜索值");
      let params = {};
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.workerUser = {};
      this.serviceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      this.workerUser.id = row.workerUserId;
      let location = {};
      console.log("集合：" + JSON.stringify(row));
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      console.log(params);
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        console.log("列表", data);
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      row.serviceItemId = this.serviceItem;
      console.log("serviceItem：" + JSON.stringify(this.serviceItem));
      insertWorkOrderMerchants(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      console.log("集合：" + JSON.stringify(row));
      updateWorkOrderMerchants(row)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success"
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
      done();
    },
    choseWorkServiceItem() {
      console.log(this.serviceCategory.id);
      findItemsByCategory(this.serviceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        this.joinsWorkServiceItems = data;
        console.log(res);
        console.log(data);
      });
      this.serviceItem = "";
    },
    choseServiceItem(data) {
      console.log(data);
      this.serviceItemId = data;
      console.log(this.serviceItemId);
    },
    userPass(row) {
      console.log(row);
      let obj = {};
      obj.id = row.id;
      userPass(obj).then(res => {
        this.handleList();
      });
    },
    userRefused(row) {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255"
      }).then(({ value }) => {
        let obj = {};
        obj.id = row.id;
        obj.reason = value;
        userRefused(obj).then(res => {
          this.handleList();
        });
      });
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then(response => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then(res => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function() {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success"
                  });
                  _this.handleList();
                }, 1000);
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error"
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then(response => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success"
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error"
          });
        });
    },
    serviceListing(row) {
      this.$router.push({ path: "stockMonitor/detail" });
      console.log(row);
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          cancelWorkOrder(id)
            .then(response => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success"
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error"
                });
              }
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        })
        .catch(() => {});
    },
    downloadExcelExportCredit() {
      // let params = this.downloadData;
      // let url = `/joins-invoice-system/v1/credit/exportCredit?`;
      // excelaxios(url, params);
      let params = this.downloadData;
      InvoiceSystemV2StatisticsDownload(params).then(res => {
        window.open(res);
      });
      // delete params.page;
      // params.size = this.page.total;
      // InvoiceSystemV2Statistics(params).then(res => {
      //   let data = JSON.parse(res.data);
      //   const list = data.rows;
      //   for (let i of list) {
      //     i.clearingType = parseStatus(DIC.FINANCIAL_STATUS, i.clearingType);
      //     i.lastPurchaseTime = formatterDateToUTC(i.lastPurchaseTime * 1);
      //     i.waitPayCount = i.waitPayCount == null ? "" : i.waitPayCount;
      //     i.waitPayPrice = i.waitPayPrice == null ? "" : i.waitPayPrice;
      //   }
      //   const header = [];
      //   for (let i of this.tableOption.column) {
      //     const obj = {};
      //     if (i.prop == "payTimeInterval" || i.prop == "startDate_endDate") {
      //       ("");
      //     } else {
      //       obj.k = i.prop;
      //       obj.v = i.label;
      //       header.push(obj);
      //     }
      //   }
      //   const fileName = "商户信用管理.xlsx";
      //   exportExcel(header, list, fileName);
      // });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(data.rows);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map(item => {
          item.waitPayPrice = item.waitPayPrice ? item.waitPayPrice : "";
          item.lastPurchaseTime = item.lastPurchaseTime
            ? formatterDateToUTC(item.lastPurchaseTime)
            : "";
          if (item.clearingType == "CASH") {
            item.clearingType = "现款现货";
          } else {
            item.clearingType = "月结";
          }
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "name", displayName: "法人名称" },
            { field: "shopAddress", displayName: "店铺地址" },
            { field: "lastPurchaseTime", displayName: "上次采购时间" },
            { field: "clearingType", displayName: "结算方式" },
            { field: "waitPayCount", displayName: "剩余未结算" },
            { field: "waitPayPrice", displayName: "未结算金额" }
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json"
        });
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}
.typeButton {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
